import InputCheckbox from '@/components/InputCheckbox';
import { classNames } from '@/helpers/strings';

import { ProfileTabConfig } from './tabConfigs';

interface ProfileTableHeaderProps {
  config: ProfileTabConfig;
  selectAll: boolean;
  onSelectAll: (value: boolean) => void;
}

export default function ProfileTableHeader({
  config,
  selectAll,
  onSelectAll,
}: ProfileTableHeaderProps) {
  return (
    <li key="ProfileListAdminHeader" className="hidden md:block">
      <div className="bg-gray-50">
        <div className="flex items-center px-4 py-2 sm:px-6">
          <div className="min-w-0 flex-1 flex items-start md:items-center">
            <div className="w-7">
              <InputCheckbox
                id="select-all"
                label=""
                value={selectAll}
                onChange={onSelectAll}
              />
            </div>
            <div
              className={classNames(
                'min-w-0 flex-1 md:grid md:grid-cols-4 md:gap-4 pr-4',
                config.gridColsXL === 6 ? 'xl:grid-cols-6' : '',
                config.gridColsXL === 7 ? 'xl:grid-cols-7' : '',
                config.gridColsXL === 8 ? 'xl:grid-cols-8' : '',
              )}
            >
              <p className="text-sm font-medium text-gray-900">
                PROFILE NAME &amp; ID
              </p>
              <p className="mt-2 md:mt-0 hidden xl:block xl:col-span-1 text-sm font-medium text-gray-900">
                ORGANISATION
              </p>
              <p className="mt-2 md:mt-0 xl:col-span-1 text-sm font-medium text-gray-900">
                STATUS
              </p>
              {config.showLinkedCardCol && (
                <p className="mt-2 md:mt-0 hidden xl:block text-sm font-medium text-gray-900">
                  LINKED CARD ID
                </p>
              )}
              <p className="mt-2 md:mt-0 hidden xl:block text-sm font-medium text-gray-900">
                ACTIVATION KEY
              </p>
              {config.showStateCol && (
                <p className="mt-2 md:mt-0 hidden xl:block text-sm font-medium text-gray-900">
                  STATE
                </p>
              )}
              <p className="mt-2 md:mt-0 xl:col-span-2 text-sm font-medium text-gray-900" />
            </div>
          </div>
          <div className="w-5" />
        </div>
      </div>
    </li>
  );
}
